export default {
  // —— Console OpenAPI ——
  'pages.openapi.overview.title': 'OpenAPI Overview',
  'pages.openapi.overview.loadFailed':
    'Failed to load usage summary (API may not be ready yet)',
  'pages.openapi.overview.docsTitle': 'Integration guide',
  'pages.openapi.overview.docsDesc':
    'OpenAPI BasePath is /v1. Response envelope is {code,message,data,request_id}. For API Keys, send Authorization: Bearer sk_live_... / sk_test_.... The plaintext key is shown only once on create or rotate—please store it securely.',
  'pages.openapi.overview.docsLink': 'View developer docs',
  'pages.openapi.overview.level': 'Current level',
  'pages.openapi.overview.qps': 'QPS limit',
  'pages.openapi.overview.apps': 'Apps',
  'pages.openapi.overview.appsSuffix':
    '(max {maxApps}, keys per app {maxKeys})',
  'pages.openapi.overview.dailyUsage': "Today's usage",

  'pages.openapi.identity.title': 'Identity & benefits at a glance',
  'pages.openapi.identity.myStatus': 'My identity',
  'pages.openapi.identity.owned': 'Active',
  'pages.openapi.identity.how': 'How',
  'pages.openapi.identity.notWhat': 'Not',
  'pages.openapi.identity.goGithub': 'GitHub verification',
  'pages.openapi.identity.goEnterprise': 'Enterprise application',
  'pages.openapi.identity.tag.user': 'Regular user',
  'pages.openapi.identity.tag.commercial': 'Commercial device bound',
  'pages.openapi.identity.tag.noCommercial': 'No commercial device',
  'pages.openapi.identity.tag.github': 'GitHub developer',
  'pages.openapi.identity.tag.noGithub': 'Not GitHub verified',
  'pages.openapi.identity.tag.enterprise': 'Enterprise developer',
  'pages.openapi.identity.tag.noEnterprise': 'Not enterprise verified',
  'pages.openapi.identity.conceptTip':
    '“Commercial certification” in casual speech may mean enterprise (B2B) or a licensed commercial device. Enterprise and GitHub are independent and can stack.',
  'pages.openapi.identity.conceptsTitle': 'Three easy-to-confuse concepts',
  'pages.openapi.identity.concept.github': 'GitHub verification',
  'pages.openapi.identity.concept.githubWhat': 'Personal developer identity',
  'pages.openapi.identity.concept.githubHow': 'Bind GitHub under Developer verification',
  'pages.openapi.identity.concept.githubNot': 'Not a login method; does not replace the platform account',
  'pages.openapi.identity.concept.enterprise': 'Enterprise verification',
  'pages.openapi.identity.concept.enterpriseWhat': 'B2B enterprise developer identity',
  'pages.openapi.identity.concept.enterpriseHow': 'Application approved, or admin provisions a Tenant',
  'pages.openapi.identity.concept.enterpriseNot': 'GitHub is not required first',
  'pages.openapi.identity.concept.commercial': 'Bound commercial licensed device',
  'pages.openapi.identity.concept.commercialWhat': 'Device-side entitlement (sub-status)',
  'pages.openapi.identity.concept.commercialHow': 'Bind a device with a valid License',
  'pages.openapi.identity.concept.commercialNot': 'Not an identity certification; independent of GitHub / enterprise',
  'pages.openapi.identity.githubCompareTitle': 'Before vs after GitHub verification',
  'pages.openapi.identity.githubCompareHint':
    'GitHub unlocks personal developer capabilities (OpenAPI, preview features, open-source device quota, KB 2→5). It does not enable KB alone—KB still needs a bound commercial device.',
  'pages.openapi.identity.enterpriseCompareTitle': 'After GitHub vs enterprise verification',
  'pages.openapi.identity.enterpriseCompareHint':
    'Enterprise covers B2B production lines and tenants; complementary to GitHub, not a substitute.',
  'pages.openapi.identity.relationTitle': 'How they relate & stack',
  'pages.openapi.identity.relationTree':
    'Regular user\n  ├─ Bind commercial device → commercial models on that device; KB cap 2\n  ├─ GitHub verification   → OpenAPI L1, preview features, open-source devices 100, KB cap 5 (still needs commercial device)\n  └─ Enterprise verification → Tenant / production / License, OpenAPI L4/L5, KB by contract\n         ↑ Independent from GitHub; can hold both',
  'pages.openapi.identity.relationComplement':
    'Complementary: commercial devices unlock KB/commercial models; GitHub upgrades developer tools & quotas; enterprise unlocks B2B production & tenants.',
  'pages.openapi.identity.relationKb':
    'KB priority: enterprise contract > GitHub’s 5 > regular user with commercial device (2) > 0.',
  'pages.openapi.identity.relationHard':
    'Hard rules: open-source devices cannot enable business KB; Tenant has no tenant-level KB.',
  'pages.openapi.identity.relationUnbind':
    'Unbinding GitHub revokes personal-developer increments; enterprise identity/capabilities remain if certified.',
  'pages.openapi.identity.col.capability': 'Capability',
  'pages.openapi.identity.col.dimension': 'Dimension',
  'pages.openapi.identity.col.beforeWithDevice': 'Not verified (has commercial device)',
  'pages.openapi.identity.col.beforeNoDevice': 'Not verified (no commercial device)',
  'pages.openapi.identity.col.afterGithub': 'After GitHub',
  'pages.openapi.identity.col.githubDev': 'GitHub (personal)',
  'pages.openapi.identity.col.enterpriseDev': 'Enterprise developer',

  'pages.openapi.status.active': 'Active',
  'pages.openapi.status.disabled': 'Disabled',

  'pages.openapi.apps.title': 'Apps & Keys',
  'pages.openapi.apps.listTitle': 'My apps',
  'pages.openapi.apps.create': 'Create app',
  'pages.openapi.apps.createModal': 'Create app',
  'pages.openapi.apps.name': 'App name',
  'pages.openapi.apps.nameRequired': 'Please enter a name',
  'pages.openapi.apps.description': 'Description',
  'pages.openapi.apps.status': 'Status',
  'pages.openapi.apps.createdAt': 'Created at',
  'pages.openapi.apps.createSuccess': 'App created',
  'pages.openapi.apps.createFailed': 'Failed to create app',
  'pages.openapi.apps.loadFailed': 'Failed to load apps',
  'pages.openapi.apps.keysLoadFailed': 'Failed to load keys',
  'pages.openapi.apps.delete': 'Delete',
  'pages.openapi.apps.deleteConfirm': 'Delete this app?',
  'pages.openapi.apps.deleted': 'Deleted',
  'pages.openapi.apps.createKey': 'Create Key',
  'pages.openapi.apps.createKeyModal': 'Create API Key',
  'pages.openapi.apps.keyCreateSuccess': 'Key created',
  'pages.openapi.apps.keyCreateFailed': 'Failed to create key',
  'pages.openapi.apps.noPlainKey': 'No plaintext key returned',
  'pages.openapi.apps.plainKeyTitle': 'Save your API Key',
  'pages.openapi.apps.plainKeyHint':
    'Plaintext is shown only once and cannot be viewed again after closing.',
  'pages.openapi.apps.copy': 'Copy',
  'pages.openapi.apps.copied': 'Copied',
  'pages.openapi.apps.copyFailed': 'Copy failed; please select manually',
  'pages.openapi.apps.close': 'Close',
  'pages.openapi.apps.key.name': 'Name',
  'pages.openapi.apps.key.namePlaceholder': 'Production primary key',
  'pages.openapi.apps.key.prefix': 'Prefix',
  'pages.openapi.apps.key.env': 'Environment',
  'pages.openapi.apps.key.status': 'Status',
  'pages.openapi.apps.key.createdAt': 'Created at',
  'pages.openapi.apps.key.disable': 'Disable',
  'pages.openapi.apps.key.disableConfirm': 'Disable this key?',
  'pages.openapi.apps.key.disabled': 'Disabled',
  'pages.openapi.apps.key.enable': 'Enable',
  'pages.openapi.apps.key.enableConfirm': 'Enable this key?',
  'pages.openapi.apps.key.enabled': 'Enabled',
  'pages.openapi.apps.key.rotate': 'Rotate',
  'pages.openapi.apps.key.rotateConfirm':
    'Rotation generates a new key and returns plaintext once. Continue?',
  'pages.openapi.apps.key.rotated': 'Rotated',
  'pages.openapi.apps.key.delete': 'Delete',
  'pages.openapi.apps.key.deleteConfirm':
    'Delete this key? This cannot be undone.',
  'pages.openapi.apps.key.deleted': 'Deleted',
  'pages.openapi.apps.webhook': 'Webhook',
  'pages.openapi.apps.webhookConfig': 'Webhook',
  'pages.openapi.apps.webhookModal': 'Configure Webhook',
  'pages.openapi.apps.webhookSaved': 'Webhook saved',
  'pages.openapi.apps.webhookUrl': 'Callback URL',
  'pages.openapi.apps.webhookUrlInvalid': 'Enter a valid URL',
  'pages.openapi.apps.rotateWebhookSecret': 'Rotate webhook_secret',
  'pages.openapi.apps.webhookSecretTitle': 'Save your Webhook Secret',
  'pages.openapi.apps.pageHintTitle': 'Apps, API Keys, and Webhooks',
  'pages.openapi.apps.pageHintDesc':
    'Apps hold your Open Platform credentials: create an API Key so your code can call our APIs. Webhooks are optional and work the other way—when a payment succeeds, a device is first activated, or a voice clone finishes, we POST to your URL so your backend can grant quota, sync orders, or notify users without polling. If you only use the console and have no backend, you can skip Webhooks. Partner act-as external users are scoped per app: different keys under the same app share the same external user; the same external user ID under different apps maps to separate shadow users.',
  'pages.openapi.apps.webhookWhatTitle': 'What is a Webhook?',
  'pages.openapi.apps.webhookWhatDesc':
    'When a business event happens, we POST to your URL (like a courier calling when a package arrives) so your server can react automatically instead of you polling APIs.',
  'pages.openapi.apps.webhookEventOrder':
    'order.paid: grant quota, update order status, send notifications',
  'pages.openapi.apps.webhookEventDevice':
    'device.activated: sync CRM/ERP or partner billing on first activation',
  'pages.openapi.apps.webhookEventClone':
    'voice_clone.completed: notify the app/mini-program that the voice is ready',
  'pages.openapi.apps.webhookOptionalHint':
    'Leave empty if you do not have a backend for these automations. Delivery requires both URL and secret.',
  'pages.openapi.apps.webhookUrlExtra':
    'Must be a publicly reachable HTTPS URL; use a tunnel for local testing. Clear and save to disable delivery.',
  'pages.openapi.apps.rotateWebhookSecretExtra':
    'The secret verifies callback signatures to prevent forged events. Rotating invalidates the old secret immediately; plaintext is shown once.',
  'pages.openapi.apps.rotateNo': 'No',
  'pages.openapi.apps.rotateYes': 'Yes (returns a new secret once)',
  'pages.openapi.apps.webhookSecretHint':
    'Shown only once. Store it on your server to verify callback signatures.',

  'pages.openapi.logs.title': 'Usage logs',
  'pages.openapi.logs.listTitle': 'Call details',
  'pages.openapi.logs.dailyTitle': 'Last 14 days usage',
  'pages.openapi.logs.dailyEmpty': 'No daily usage data',
  'pages.openapi.logs.date': 'Date',
  'pages.openapi.logs.count': 'Calls',
  'pages.openapi.logs.createdAt': 'Time',
  'pages.openapi.logs.requestId': 'Request ID',
  'pages.openapi.logs.requestIdPlaceholder': 'Paste the request_id from the API response',
  'pages.openapi.logs.detail': 'Details',
  'pages.openapi.logs.detailTitle': 'Call details',
  'pages.openapi.logs.detailLoading': 'Loading…',
  'pages.openapi.logs.requestQuery': 'Query',
  'pages.openapi.logs.requestBody': 'Request',
  'pages.openapi.logs.responseBody': 'Response',
  'pages.openapi.logs.app': 'App',
  'pages.openapi.logs.appId': 'App ID',
  'pages.openapi.logs.apiKey': 'API Key',
  'pages.openapi.logs.userId': 'User ID',
  'pages.openapi.logs.apiKeyId': 'Key ID',
  'pages.openapi.logs.keyPrefix': 'Key prefix',
  'pages.openapi.logs.method': 'Method',
  'pages.openapi.logs.path': 'Path',
  'pages.openapi.logs.statusCode': 'HTTP',
  'pages.openapi.logs.code': 'Biz code',
  'pages.openapi.logs.latency': 'Latency (ms)',
  'pages.openapi.logs.loadFailed': 'Failed to load',

  'pages.openapi.planTiers.title': 'OpenAPI plan tiers',
  'pages.openapi.planTiers.level': 'Level',
  'pages.openapi.planTiers.levelTip':
    'Plan tier level (1–5), aligned with the user profile Level. Higher numbers mean higher tiers.',
  'pages.openapi.planTiers.name': 'Name',
  'pages.openapi.planTiers.qps': 'QPS',
  'pages.openapi.planTiers.qpsTip':
    'Max requests per second (Queries Per Second). Default rate limit for API Key calls on this tier: sustained rate equals this value; burst capacity is about QPS×2 (at least 5). Applies only to API Key calls; console/admin traffic is not counted. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42901).',
  'pages.openapi.planTiers.dailyQuota': 'Daily quota',
  'pages.openapi.planTiers.dailyQuotaTip':
    'Max total API requests allowed per calendar day. Counted per user/key; only API Key calls count. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42902).',
  'pages.openapi.planTiers.maxApps': 'Max apps',
  'pages.openapi.planTiers.maxAppsTip':
    'Maximum number of OpenAPI apps a developer on this tier can create.',
  'pages.openapi.planTiers.maxKeys': 'Max keys per app',
  'pages.openapi.planTiers.maxKeysTip': 'Maximum number of API keys allowed under each app.',
  'pages.openapi.planTiers.allowedScopes': 'Allowed permissions (scopes)',
  'pages.openapi.planTiers.allowedScopesTip':
    'API permission scopes this tier may request or be granted. App and API Key scopes must be a subset of this selection.',
  'pages.openapi.planTiers.save': 'Save',
  'pages.openapi.planTiers.saved': 'Saved',
  'pages.openapi.planTiers.saveFailed': 'Save failed',
  'pages.openapi.planTiers.loadFailed': 'Failed to load plan tiers',
  'pages.openapi.planTiers.readonly':
    'Observers have read-only access and cannot edit plan tiers',

  'pages.openapi.scope.agentsRead': 'Agents · Read',
  'pages.openapi.scope.agentsWrite': 'Agents · Write',
  'pages.openapi.scope.devicesRead': 'Devices · Read',
  'pages.openapi.scope.devicesWrite': 'Devices · Write',
  'pages.openapi.scope.chatsRead': 'Chats · Read',
  'pages.openapi.scope.voicesRead': 'Voices / Clone · Read',
  'pages.openapi.scope.voicesWrite': 'Voices / Clone · Write',
  'pages.openapi.scope.kbRead': 'Knowledge base · Read',
  'pages.openapi.scope.kbWrite': 'Knowledge base · Write',
  'pages.openapi.scope.ordersRead': 'Orders · Read',
  'pages.openapi.scope.ordersWrite': 'Orders · Write',
  'pages.openapi.scope.statsRead': 'Usage stats · Read',
  'pages.openapi.scope.todosRead': 'Todos · Read',
  'pages.openapi.scope.todosWrite': 'Todos · Write',
  'pages.openapi.scope.tenantsRead': 'Tenants · Read',
  'pages.openapi.scope.tenantsWrite': 'Tenants · Write',
  'pages.openapi.scope.productionWrite': 'Production · Write',
  'pages.openapi.scope.adminWrite': 'Admin · Write',
  'pages.openapi.scope.partnerActAs': 'Partner act-as (external user context)',

  'pages.openapi.usersUsage.title': 'OpenAPI user limits & today usage',
  'pages.openapi.usersUsage.userId': 'User ID',
  'pages.openapi.usersUsage.username': 'Username',
  'pages.openapi.usersUsage.level': 'Level',
  'pages.openapi.usersUsage.developerEnabled': 'Developer status',
  'pages.openapi.usersUsage.plan': 'Plan',
  'pages.openapi.usersUsage.rateLimitQps': 'QPS limit',
  'pages.openapi.usersUsage.dailyQuota': 'Daily quota',
  'pages.openapi.usersUsage.todayUsed': 'Today used',
  'pages.openapi.usersUsage.loadFailed': 'Failed to load',

  'pages.openapi.admin.usageLogsTitle': 'OpenAPI usage audit',
  'pages.openapi.admin.usageLogsList': 'Global call logs',
  'pages.openapi.admin.disableKeyConfirm': 'Disable this API Key?',
  'pages.openapi.admin.disableKey': 'Disable Key',
  'pages.openapi.admin.keyDisabled': 'Disabled',
  'pages.openapi.admin.appsTitle': 'OpenAPI apps',
  'pages.openapi.admin.appsList': 'All developer apps',
  'pages.openapi.admin.developers': 'Developers',
  'pages.openapi.admin.apps': 'Apps',
  'pages.openapi.admin.keys': 'Total keys',
  'pages.openapi.admin.activeKeys': 'Active keys',
  'pages.openapi.admin.todayRequests': 'Today calls',
  'pages.openapi.admin.todayErrors': 'Today errors',
  'pages.openapi.admin.errorCount': 'Errors',
  'pages.openapi.admin.owner': 'Owner',
  'pages.openapi.admin.keyCount': 'Keys',
  'pages.openapi.admin.keyword': 'Keyword',
  'pages.openapi.admin.keywordPlaceholder': 'App name / description / tenant code',
  'pages.openapi.admin.statsLoadFailed': 'Failed to load stats',
  'pages.openapi.admin.noKeys': 'No keys',
  'pages.openapi.admin.appEnabled': 'App enabled',
  'pages.openapi.admin.appDisabled': 'App disabled',
  'pages.openapi.admin.appDisableConfirm': 'Disable this app?',
  'pages.openapi.admin.appEnableConfirm': 'Enable this app?',
  'pages.openapi.admin.keyEnableConfirm': 'Enable this key?',

  'pages.openapi.key.detailTitle': 'Key details',
  'pages.openapi.key.scopes': 'Configured scopes',
  'pages.openapi.key.effectiveScopes': 'Effective scopes',
  'pages.openapi.key.saveScopes': 'Save scopes',
  'pages.openapi.key.scopesSaved': 'Scopes saved',
  'pages.openapi.key.scopesSaveFailed': 'Failed to save scopes',
  'pages.openapi.key.noAllowedScopes':
    'Owner plan has no allowed_scopes configured. Maintain the plan tier first.',
  'pages.openapi.key.selectAllAllowed': 'Select all allowed',
  'pages.openapi.key.clearScopes': 'Clear',
  'pages.openapi.key.outOfPlanHint':
    'This key has {count} scope(s) outside the current plan; they are hidden here and will be removed on save.',
  'pages.openapi.key.scopesHint':
    'Only scopes in the owner plan allowed_scopes are shown and editable. Saving overwrites the key scopes and takes effect immediately.',

  'pages.admin.user.openapiDeveloperEnabled': 'OpenAPI',
  'pages.admin.user.openapi.on': 'Enabled',
  'pages.admin.user.openapi.off': 'Disabled',
  'pages.admin.user.openapiLevel': 'OpenAPI level',
  'pages.admin.user.openapiDeveloperEnabled.label': 'Enable developer',
  'pages.admin.user.openapiLevel.label': 'Level',
  'pages.admin.user.openapiLevel.placeholder': '1-5',

  'pages.openapi.partner.adminTitle': 'Partner external user links',
  'pages.openapi.partner.adminList': 'Link list',
  'pages.openapi.partner.externalUserId': 'External user ID',
  'pages.openapi.partner.externalUserIdPlaceholder': 'Fuzzy search',
  'pages.openapi.partner.userId': 'Shadow user ID',
  'pages.openapi.partner.appId': 'App ID',
  'pages.openapi.partner.app': 'App',
  'pages.openapi.partner.appNamePlaceholder': 'App name (fuzzy)',
  'pages.openapi.partner.ownerPlaceholder': 'Owner username (fuzzy)',
  'pages.openapi.partner.shadowUser': 'Shadow user',
  'pages.openapi.partner.userDisabled': 'Shadow user disabled',
  'pages.openapi.partner.tenantCode': 'Tenant code',
  'pages.openapi.partner.displayName': 'Display name',
  'pages.openapi.partner.displayNamePlaceholder': 'Display name (fuzzy)',
  'pages.openapi.partner.disableConfirm':
    'Disable this link? The shadow user will also be disabled and act-as calls will return 403.',
  'pages.openapi.partner.enableConfirm': 'Enable this link?',
  'pages.openapi.partner.disabled': 'Disabled',
  'pages.openapi.partner.enabled': 'Enabled',
  'pages.openapi.partner.drawerTitle': 'External user links',
  'pages.openapi.partner.openLinks': 'External users',
  'pages.openapi.partner.scopeHintTitle':
    'Scoped by app — not shared across the whole enterprise account',
  'pages.openapi.partner.scopeHintDesc':
    'External user links are keyed by app + external user ID. Different API keys under the same app with the same external user ID share one shadow user and resources; under different apps of the same enterprise owner, the same external ID maps to separate shadow users (devices and agents are not shared).',
  'pages.openapi.partner.drawerScopeHintDesc':
    'This list is only for the current app. Any API key under this app with the same external user ID shares one shadow user; the same external ID under other apps does not appear here and does not share devices or agents.',
};
